import { RenderIf } from 'react-rainbow-components';
import { EDIT_MEMORY_MODAL } from '../../../../constants';
import {
    EmptyStateMessage, EmptyStateContainer, EmptyStateIcon, EmptyStateTitle,
    CenteredContent,
} from '../../styled';
import {
    MemoriesWrapper,
} from './styled';
import {
    Memory,
} from '../../types';
import MemoryCard from './MemoryCard';
import EditMemoryForm from '../EditMemoryForm';

interface MomeriesTableProps {
    memories: Memory[];
}

const MemoriesTable = ({ memories }: MomeriesTableProps) => (
    <MemoriesWrapper>
        <RenderIf isTrue={memories.length > 0}>
            {memories.map((memory) => (
                <MemoryCard key={memory.id} value={memory} />
            ))}
            <EditMemoryForm modalId={EDIT_MEMORY_MODAL} />
        </RenderIf>
        <RenderIf isTrue={memories.length === 0}>
            <CenteredContent>
                <EmptyStateContainer>
                    <EmptyStateIcon>🔍</EmptyStateIcon>
                    <EmptyStateTitle>No Memories Found</EmptyStateTitle>
                    <EmptyStateMessage>
                        We couldn&apos;t find any memories matching your filters.
                        Try adjusting your filter criteria or selecting different
                        memory types to see more results.
                    </EmptyStateMessage>
                </EmptyStateContainer>
            </CenteredContent>
        </RenderIf>
    </MemoriesWrapper>
);

export default MemoriesTable;
